import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import 'moment-timezone';
import { NgxSpinnerService } from "ngx-spinner";

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    selector: 'app-excel-report',
    templateUrl: './excel-report.component.html',
    styleUrls: ['./excel-report.component.css']
})
export class ExcelReportComponent implements OnInit {

    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public project_id: any = {};
    public mentions = [];
    public numerical: any = {};
    public summary: any = {};
    public categories: any = {};
    public progress: any = { mentions: false, sentiment: false, categories: false, numeric: false };
    public display = 'none';
    public blocked_items: any = {};
    fileName = 'Report.xlsx';

    constructor(private router: Router, private service: DashboardService, private spinner: NgxSpinnerService, private login: LoginService, private route: ActivatedRoute, private _location: Location) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.session_data.role = login.get_session_data('ieye_session_role');
        this.service.setTitle('Excel Report | 24ieye');
        this.project_id = this.route.snapshot.queryParams["id"];
    }

    ngOnInit(): void {
        this.generate_reports();
    }

    public generate_popup() {
        this.spinner.hide();
        Swal.fire({
            title: 'Generate Excel Report',
            text: "",
            icon: 'info',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Generate'
        }).then((action) => {
            if (action.isConfirmed) {
                this.download_report();
            } else {
                this.router.navigate(['projects']);
            }
        });
    }

    public generate_reports() {
        this.spinner.show();
        this.generate_mentions();
        this.generate_summary();
        this.get_mentions_per_sm();
        this.get_mentions_numerical();
    }

    public async generate_summary() {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("start_date", moment().subtract(90, 'days').format("YYYY-MM-DD"));
        formData.append("end_date", moment().format("YYYY-MM-DD"));
        formData.append("project_id", this.project_id);
        formData.append("type", 'summary');
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {

        } else {
            this.summary = this.result.data;
            this.summary.percentage_neutral = this.get_percentage(this.summary.interactions, this.summary.total);
            this.summary.percentage_positive = this.get_percentage(this.summary.positive, this.summary.total);
            this.summary.percentage_negative = this.get_percentage(this.summary.negative, this.summary.total);
            this.progress.sentiment = true;
        }
        if (this.progress.mentions && this.progress.sentiment && this.progress.categories && this.progress.numeric)
            this.generate_popup();
    }

    public async generate_mentions() {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("start_date", moment().subtract(90, 'days').format("YYYY-MM-DD"));
        formData.append("end_date", moment().format("YYYY-MM-DD"));
        formData.append("project_id", this.project_id);
        formData.append("per_page", 10000);
        formData.append("type", 'all');
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {

        } else {
            this.mentions = this.result.data.mentions;
            this.blocked_items.mentions = this.result.user.blocked_mentions;
            this.blocked_items.profiles = this.result.user.blocked_profiles;
            this.progress.mentions = true;
        }
        if (this.progress.mentions && this.progress.sentiment && this.progress.categories && this.progress.numeric)
            this.generate_popup();
    }

    public async get_mentions_numerical() {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("start_date", moment().subtract(90, 'days').format("YYYY-MM-DD"));
        formData.append("end_date", moment().format("YYYY-MM-DD"));
        formData.append("project_id", this.project_id);
        formData.append("type", 'numerical');
        formData.append("sentiment_data", true);
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {

        } else {
            this.numerical = this.result;
            this.progress.numeric = true;
        }
        if (this.progress.mentions && this.progress.sentiment && this.progress.categories && this.progress.numeric)
            this.generate_popup();
    }

    public async get_mentions_per_sm() {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("start_date", moment().subtract(90, 'days').format("YYYY-MM-DD"));
        formData.append("end_date", moment().format("YYYY-MM-DD"));
        formData.append("project_id", this.project_id);
        formData.append("type", 'count_per_sm');
        formData.append("per_page", 10);
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.spinner.hide();
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.fileName = this.get_file_name(this.result.project);
            this.categories.web = this.result.data.web;
            this.categories.twitter = this.result.data.twitter;
            this.categories.instagram = this.result.data.instagram;
            this.categories.facebook = this.result.data.facebook;
            this.categories.youtube = this.result.data.youtube;
            this.categories.reviews = this.result.data.reviews;
            this.categories.others = this.result.data.others;
            this.categories.linkedin = this.result.data.linkedin;
            this.categories.reddit = this.result.data.reddit;
            this.progress.categories = true;
        }
        if (this.progress.mentions && this.progress.sentiment && this.progress.categories && this.progress.numeric)
            this.generate_popup();
    }

    public get_file_name(input) {
        var slug = input.toLowerCase().trim();
        slug = slug.replace(/[^a-z0-9\s-]/g, ' ');
        slug = slug.replace(/[\s-]+/g, '-');
        slug = slug + '-' + moment().tz('Asia/Muscat').format('YYYY-MM-DD-HH-mm') + '.xlsx';
        return slug;
    }

    public download_report() {
        this.spinner.show();
        if (this.session_data.role == 2)
            this.login.create_log(this.session_data.id, 'excel');
        let mentions_data = document.getElementById('mentions-table');
        const mentions_ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(mentions_data);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, mentions_ws, 'Mentions');

        let summary_data = document.getElementById('summary-table');
        const summary_ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(summary_data);
        XLSX.utils.book_append_sheet(wb, summary_ws, 'Sentiment');

        let category_data = document.getElementById('category-table');
        const cat_ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(category_data);
        XLSX.utils.book_append_sheet(wb, cat_ws, 'Categories');

        let numerical_data = document.getElementById('numerical-table');
        const num_ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(numerical_data);
        XLSX.utils.book_append_sheet(wb, num_ws, 'Numerical Data');

        XLSX.writeFile(wb, this.fileName);
        this._location.back();
    }

    public change_date_format(date, format) {
        return moment.tz(date, 'Asia/Muscat').utc().format(format);
    }

    public get_percentage(value, total) {
        return Math.floor(((value / total) * 100) + 0.5);
    }

    public can_show_mention(id, profile_id) {
        var mentions = JSON.stringify(this.blocked_items.mentions);
        var profiles = JSON.stringify(this.blocked_items.profiles);
        if (mentions.indexOf(id) !== -1 || profiles.indexOf(profile_id) !== -1) {
            return 'none';
        }
        return 'table-row';
    }

}
